<template>
    <v-dialog
        width="35%"
        v-model="dialog"
        @click:outside="close"
        @keydown.esc="close"
    >
        <v-card>
            <v-card-title>
                Urheberrecht
            </v-card-title>

            <v-card-text>
                Beachte:
                Du als Autor musst der Urheber des gesamten Inhalts deiner Andacht sein.
                Jedes Zitat oder die Wiederverwendung von Gedanken muss gekennzeichnet werden.
                Außerdem musst du prüfen, ob ein Zitat dem Copyright unterliegt und in dieser Form zitiert werden darf
                (das gilt vor allem für Gedichte, Liedverse etc.).
            </v-card-text>

            <v-card-actions>
                <v-spacer />

                <v-btn outlined @click="accept">
                    Bestätigen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogNotice",
    props: {
        dialog: Boolean
    },
    methods: {
        close() {
            this.$emit('close');
        },
        accept() {
            this.$emit('accept')
        }
    }
}
</script>